
<div class="row row-sm" >
    <div class="col-lg-12">
            <div class="card-body">
  <div class="row">
    <div class="col-md-12" *ngIf="submitButton">
        <div class=" bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/StateMaster.png" class="mh-45px pb-2">
            <div class="ml-2">
              <h4 class="main-content-label mb-1"><b>
                {{'header.state-data.table.State'| translate}}
              </b></h4>
              <p class="text-muted card-sub-title mb-0">
                {{'header.state-data.table.AddNewStateRecord' | translate}}
              </p>
            </div>
          </div> 
    </div>
    <div class="col-md-12"  *ngIf="editButton">
        <div class=" bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/StateMaster.png" class="mh-45px pb-2">
            <div class="ml-2">
              <h4 class="main-content-label mb-1"><b>
                {{'header.state-data.table.State'| translate}}
              </b></h4>
              <p class="text-muted card-sub-title mb-0">
                {{'header.state-data.table.UpdateStateRecord' |
                translate}}
              </p>
            </div>
          </div> 
    </div>
    <div class="col-md-12" *ngIf="deleteButton">
        <div class=" bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/StateMaster.png" class="mh-45px pb-2">
            <div class="ml-2">
              <h4 class="main-content-label mb-1"><b>
                {{'header.state-data.table.State'| translate}}
              </b></h4>
              <p class="text-muted card-sub-title mb-0">
              {{'header.state-data.table.DeleteStateRecord' |
              translate}}
              </p>
            </div>
          </div> 
    </div>
    <hr class="mt-3">

    
    
    
<div class="row row-sm add-form " >
    <form autocomplete="off" class="p-0" novalidate [formGroup]="StateForm ">
        <div class="col-lg-12 col-md-12">
                    <div class="row clearfix ">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width " >
                                        <mat-label>{{'header.country-data.table.CountryName' | translate }}</mat-label>
                                        <mat-select [disabled]="isreadonly || isreadonlydel"  #select23 class="color" formControlName="CountryCode">
                                            <mat-select-filter *ngIf="select23.focused"
                                                [placeholder]="'Filter'" [displayMember]="'CountryName'"
                                                [array]="CountryCodeList"
                                                (filteredReturn)="filteredListCountryCode =$event"></mat-select-filter>
                                            <mat-option *ngFor="let item of filteredListCountryCode"
                                                [value]="item.CountryCode">
                                                {{item.CountryName}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                        *ngIf="StateForm.controls['CountryCode'].touched && StateForm.controls['CountryCode'].errors?.required">
                                        {{'header.country-data.table.Mandatory' | translate }}
                                    </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width " >
                                        <mat-label>
                                            {{'header.state-data.table.StateCode' |
                                            translate }}
                                        </mat-label>
                                        <input appUppercase onkeydown="return (event.keyCode!=13);" [readonly]='isreadonly || isreadonlydel' class="color" type="text" maxlength="5"
                                            placeholder="State Code" formControlName="StateCode" 
                                            matInput required>
                                            <mat-error class="margin_tp"
                                                *ngIf="StateForm.controls['StateCode'].touched && StateForm.controls['StateCode'].errors?.required">
                                                {{'header.country-data.table.Mandatory' | translate }}
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="StateForm.controls['StateCode'].touched && StateForm.controls['StateCode'].errors?.pattern">
                                                {{'header.country-data.table.Invalid' | translate }}
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width " >
                                        <mat-label>
                                            {{'header.state-data.table.StateName' |
                                            translate }}
                                        </mat-label>
                                        <input appCamelcase onkeydown="return (event.keyCode!=13);" class="color" type="text" maxlength="25" [readonly]="isreadonlydel"
                                            placeholder="State Name" formControlName="StateName"
                                            matInput required>
                                            <mat-error class="margin_tp"
                                                *ngIf="StateForm.controls['StateName'].touched && StateForm.controls['StateName'].errors?.required">
                                                 {{'header.country-data.table.Mandatory' | translate }}
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="StateForm.controls['StateName'].touched && StateForm.controls['StateName'].errors?.pattern">
                                                {{'header.country-data.table.Invalid' | translate }}
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row mb-2 prpl">

                            <div class="col-sm-12" >
                                <button id="Save" type="button" *ngIf="submitButton && stateCreate"
                                class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                 (click)="submit()">
                                <span style="display: contents; align-items: center;">
                                     <img width="30%" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                     {{'header.country-data.table.Save' | translate }}
                                </span>
                                </button>
                                <button id="Update" type="button" *ngIf="editButton && stateUpdate"
                                class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                 (click)="update()">
                                <span style="display: contents; align-items: center;">
                                     <img width="29%" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                      {{'header.country-data.table.Update' | translate }}
                                </span>
                                </button>
                                <button id="Delete" type="button" *ngIf="deleteButton && stateDelete"
                                class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                                 (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                     <img width="30%" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                      {{'header.country-data.table.Delete' | translate }}
                                </span>
                                </button>
                                <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn fr sz btn-primary btn-icon-text floatright mt-1">
                            <span style="display: contents; align-items: center; margin-left:1rem;">
                                 <img width="23%" src="../../assets/img/turn-left.gif" style="margin-right: 5px;">
                                 {{'header.country-data.table.Back' | translate }}
                            </span>
                            </button>
                           
                            </div>
                        </div>

                    </div>
                
            
        </div>
    </form>
    </div>
    </div>
    </div>

    </div>
    </div>